"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectButtonSlots = exports.default = exports.SelectButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _selectButtonClasses = _interopRequireWildcard(require("./selectButtonClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getSelectButtonSlots = ownerState => {
  const {
    disabled,
    selected
  } = ownerState;
  return {
    root: ['root', disabled && 'disabled', selected && 'selected'],
    content: ['content']
  };
};
exports.getSelectButtonSlots = getSelectButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSelectButtonSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _selectButtonClasses.getSelectButtonUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const SelectButtonRoot = (0, _mui.styled)(_mui.ButtonBase, {
  name: 'SelectButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [ownerState.disabled && styles.disabled, ownerState.selected && styles.selected],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateColumns: '24px 1fr',
  gridTemplateRows: '1fr',
  gap: 15,
  alignItems: 'center',
  ...(ownerState.contentAlign === 'start' && {
    alignItems: 'start'
  }),
  justifyItems: 'start',
  justifyContent: 'stretch',
  padding: theme.spacing(4, 3),
  background: theme.palette.common.white,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  textAlign: 'left',
  border: 'none',
  boxShadow: 'none',
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 6)
  },
  '&:hover': {
    background: theme.palette.grey[100],
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${_selectButtonClasses.default.selected}`]: {
    background: theme.palette.grey[100],
    ...(ownerState.indicator === 'radio' && {
      cursor: 'default'
    })
  },
  [`&.${_selectButtonClasses.default.disabled}`]: {
    background: theme.palette.common.white,
    color: theme.palette.text.disabled
  },
  [`&.${_selectButtonClasses.default.focusVisible}`]: {
    borderRadius: 'inherit',
    outline: `2px solid ${theme.palette.default.dark}`,
    outlineOffset: -2
  }
}));
const SelectButtonContent = (0, _mui.styled)('div', {
  name: 'SelectButton',
  slot: 'Content',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.content]
})(({
  theme,
  ownerState
}) => ({
  justifySelf: 'stretch',
  display: 'block',
  overflow: 'hidden',
  textAlign: 'left',
  color: theme.palette.text.primary,
  ...(ownerState.disabled && {
    color: theme.palette.action.disabled
  }),
  '&:hover': {
    color: theme.palette.text.primary,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}));
const SelectButton = exports.SelectButton = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'SelectButton'
  });
  const {
    children,
    className,
    contentAlign = 'center',
    dataTestId,
    disabled = false,
    disableFocusRipple = false,
    indicator = 'radio',
    selected = false,
    ...other
  } = props;
  const indicatorIcon = (0, _react.useMemo)(() => {
    if (indicator === 'radio' && selected) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RadioButtonChecked, {
        fontSize: "medium"
      });
    } else if (indicator === 'checkbox' && selected) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxChecked, {
        fontSize: "medium"
      });
    } else if (indicator === 'checkbox' && !selected) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxEmpty, {
        fontSize: "medium"
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RadioButtonEmpty, {
      fontSize: "medium"
    });
  }, [indicator, selected]);
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    contentAlign,
    disabled,
    indicator,
    selected
  }), [props, contentAlign, disabled, indicator, selected]);
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SelectButtonRoot, {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className),
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ownerState: ownerState,
    "data-testid": dataTestId,
    ...other,
    children: [indicatorIcon, /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectButtonContent, {
      ownerState: ownerState,
      className: classes.content,
      children: children
    })]
  });
});
var _default = exports.default = SelectButton;
